import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";

import ColorUtil from "@plannel/pages/utils/color-util";
import { FS } from "@plannel/utils/font-util";

/**
 * 태그 알약 하나.
 *
 * <p><b>미리 깔아 둔 태그만 색을 받는다</b>(S&OP · DP · RP · IP · MP · Data · Common).
 * 자유 입력 태그는 중립색이다 — 전부 칠하면 어느 색도 뜻을 갖지 못하고, 색이 붙어 있다는 것
 * 자체가 "이건 정해진 축" 이라는 표시가 된다.
 *
 * <p>계획 모듈은 Home 과 <b>같은 색</b>이다. 이 앱은 "색이 곧 소속" 이라 DP 는 어디서든 한
 * 색이어야 한다 — 색은 {@link ColorUtil#agendaTagColor} 하나에서만 나온다.
 */
const AgendaTagChip = ({ tag, dense = false }) => {
  const hex = ColorUtil.agendaTagColor(tag);
  return (
    <Box
      sx={{
        fontSize: FS.CAPTION,
        fontWeight: 600,
        border: 1,
        borderRadius: 5,
        px: 1,
        py: dense ? 0.125 : 0.25,
        whiteSpace: "nowrap",
        ...(hex
          ? { color: hex, bgcolor: alpha(hex, 0.12), borderColor: alpha(hex, 0.45) }
          : { color: "text.secondary", bgcolor: "action.hover", borderColor: "divider" })
      }}
    >
      {tag}
    </Box>
  );
};

export default AgendaTagChip;
